import React, { createContext, useReducer, useEffect, useState } from 'react';
import { api } from 'api';

export const PortfolioContext = createContext();

export default function PortfolioProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);
  const [monitor, setMonitor] = useState(null);

  useEffect(() => {
    if (monitor) {
      var list = [];
      list.push(monitor.monitorId);
      api.portfolio.getMonitorPortfolio(list).then((data) => {
        if (!data.error) {
          dispatch({ type: 'UPDATE_COLLECTION', payload: data });
        }
      });
    }
  }, [monitor]);

  function selectPortfolioMonitor(monitor) {
    setMonitor(monitor);
  }

  return (
    <PortfolioContext.Provider value={{ ...state, selectPortfolioMonitor }}>
      {children}
    </PortfolioContext.Provider>
  );
}

export const usePortfolio = () => React.useContext(PortfolioContext);

function reducer(state, { type, payload }) {
  switch (type) {
    case 'UPDATE_COLLECTION':
      return {
        ...state,
        data: payload,
        status: 'loaded',
      };
    case 'SELECT':
      return { ...state, selected: payload };
    default:
      return state;
  }
}

const initialState = {
  status: 'loading',
  data: [],
  selected: null,
};
